export default {
  provinces: null,
  wasProvincesResponseEmpty: false,
  isProvincesPopulated: false,
  isPostUpgradeToClubLoading: false,
  postUpgradeToClubError: null,
  isProvincesLoading: false,
  isProviceLoadingFailed: false,
}
